export default function RemoveIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 8H12" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
